const endpoints = {
	ACCOUNT_PROFILE: 					process.env.REACT_APP_API_URL+'/account/profile',
	ACCOUNT_PAYMENT_METHODS: 	process.env.REACT_APP_API_URL+'/account/payment_methods',
	ACCOUNT_USERS: 						process.env.REACT_APP_API_URL+'/account/users',
	ACCOUNT_BANKING: 					process.env.REACT_APP_API_URL+'/account/banking',
	ACCOUNT_INTEGRATIONS: 		process.env.REACT_APP_API_URL+'/account/integrations',
	ACCOUNT_CONTACT: 					process.env.REACT_APP_API_URL+'/account/contact',
	INVITE: 									process.env.REACT_APP_API_URL+'/invites',
	INVOICES: 								process.env.REACT_APP_API_URL+'/invoices',
	LOGIN: 										process.env.REACT_APP_API_URL+'/auth/login',
	REGISTER: 								process.env.REACT_APP_API_URL+'/auth/register',
	VALIDATE_INVITE: 					process.env.REACT_APP_API_URL+'/invites/validate_code',
	STORE_CUSTOMER: 					process.env.REACT_APP_API_URL+'/saastic/customer', 
	STORE_CUSTOMER_CSV: 			process.env.REACT_APP_API_URL+'/saastic/customer/upload', 
	UPDATE_SAASTIC: 					process.env.REACT_APP_API_URL+'/saastic/profile', 
};

export default endpoints;